import { SuiteManifest } from '../manifest';
import { peopleRoutes } from './routes';
import { peopleNavItems } from './nav';

export const peopleManifest: SuiteManifest = {
  id: 'people',
  name: 'People & HR',
  basePath: '/people',
  icon: 'users',
  description: 'Workforce records, org chart reporting hierarchy, leave requests, and payroll-lite.',
  requiredPermission: 'people.read',
  nav: peopleNavItems,
  routes: peopleRoutes,
};

export default peopleManifest;
